import { login } from "@/api/user";
import { getBrand, setBrand, getToken, setToken } from "@/utils/auth";
import { createStore, Store } from 'vuex';

class View {
    constructor(name, path) {
        this.name = name;
        this.path = path;
    }
}

const store = createStore({
    state: {
        user: {
            brand: getBrand(),  // 公司Id
            token: getToken(),
            roles: [],
            email: ''
        },
        tagsView: {
            visitedViews: [],
            cachedViews: []
        }
    },
    getters: {
        token: state => state.user.token,
        brand: state => state.user.brand,
        roles: state => state.user.roles,
        email: state => state.user.email,
    },
    mutations: {
        SET_Brand: (state, brand) => {
            state.user.brand = brand;
        },
        SET_TOKEN: (state, token) => {
            state.user.token = token;
        },
        SET_EMAIL: (state, email) => {
            state.user.email = email;
        },
        ADD_VISITED_VIEW: (state, view) => {
            if (state.tagsView.visitedViews.some(v => v.path === view.path)) {
                return;
            }

            state.tagsView.visitedViews.push(
                Object.assign({}, view, {
                    title: view.meta.title || 'no-name'
                })
            );
        },
        ADD_CACHED_VIEW: (state, view) => {
            if (state.tagsView.cachedViews.includes(view.name)) {
                return;
            }

            if (!view.meta.noCache) {
                state.tagsView.cachedViews.push(view.name);
            }
        }
    },
    actions: {
        login({ commit }, loginInfo) {
            return new Promise((resolve, reject) => {
                login(loginInfo).then(response => {
                    commit('SET_TOKEN', response.data.token);
                    commit('SET_Brand', response.data.brand);
                    commit('SET_EMAIL', response.data.email);

                    setBrand(response.data.brand);
                    setToken(response.data.token);

                    resolve("");
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addVisitedView({ commit }, view) {
            commit('ADD_VISITED_VIEW', view);
        },
        addView({ dispatch }, view) {
            dispatch('addVisitedView', view);
            dispatch('addCachedView', view);
        },
        addCachedView({ commit }, view) {
            commit('ADD_CACHED_VIEW', view);
        }
    }
});

export default store;